import { DialogType, ModalType, SimpleDialogParams } from '../interfaces/simple-dialog';
import { SimpleDialog } from '../controllers/dialog-helper';

interface DialogServiceProps {
  descriptionDialog?: string;
  onClickCancel?: () => void;
  onClickOk: () => void;
  titleDialog: string;
  titleOnCancel: string;
  titleOnOk: string;
}

export default class DialogService {

  public static open({
    descriptionDialog,
    onClickCancel,
    onClickOk,
    titleDialog,
    titleOnCancel,
    titleOnOk
  }: DialogServiceProps): void {
    const desc = descriptionDialog !== '' ? descriptionDialog : undefined;
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: desc,
      dialogType: DialogType.ACTION,
      modalType: ModalType.DIALOG,
      onClickCancel,
      onClickOk,
      titleDialog,
      titleOnCancel,
      titleOnOk,
    };

    SimpleDialog.openDialog(dialogParams);
  }
}
